import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import api from "./api";
import Layout from "./Layout";
import Login from "./pages/Login";
import Gpus from "./pages/Gpus";
import Generators from "./pages/Generators";
import Playground from "./pages/Playground";
import Queue from "./pages/Queue";
import Tokens from "./pages/Tokens";
import Settings from "./pages/Settings";
import Classifiers from "./pages/Classifiers";
import ClassifierPlayground from "./pages/ClassifierPlayground";
import VllmModels from "./pages/VllmModels";
import ModelRegistry from "./pages/ModelRegistry";

export default function App() {
  const [authed, setAuthed] = useState(null); // null = checking

  useEffect(() => {
    api.get("/api/me", { silent: true }).then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  if (authed === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={authed ? <Navigate to="/gpus" replace /> : <Login onIn={() => setAuthed(true)} />}
      />
      {!authed ? (
        <Route path="*" element={<Navigate to="/login" replace />} />
      ) : (
        <Route element={<Layout onSignOut={() => setAuthed(false)} />}>
          <Route path="/" element={<Navigate to="/gpus" replace />} />
          <Route path="/gpus" element={<Gpus />} />
          <Route path="/generators" element={<Generators />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/queue" element={<Queue />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/classifiers" element={<Classifiers />} />
          <Route path="/classifier-playground" element={<ClassifierPlayground />} />
          <Route path="/vllm-models" element={<VllmModels />} />
          <Route path="/model-registry" element={<ModelRegistry />} />
          <Route path="*" element={<Navigate to="/gpus" replace />} />
        </Route>
      )}
    </Routes>
  );
}
